import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

/**
 * V2 copy of components/Modal/Modal.jsx (TransitionsModal). Same auto-close +
 * optional "redirect home" countdown, themed. The redirect target is passed in
 * (`redirectTo`) so the public site sends a converting customer to "/" while the
 * dev preview keeps them inside /dev-preview. Defaults to the public home.
 */
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(92vw, 460px)",
  background: "linear-gradient(160deg, #2a0f3a, #122a5c)",
  border: "1px solid rgba(255,255,255,0.25)",
  color: "#fff",
  borderRadius: "16px",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

const TransitionsModalV2 = ({ modalOpen, handleClose, modalText, redirectTo = "/" }) => {
  const [redirectStop, setRedirectStop] = useState(false);
  const [counter, setCounter] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (modalOpen === true) {
      setCounter(5);
      const t = setTimeout(() => handleClose(), modalText.time);
      return () => clearTimeout(t);
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  useEffect(() => {
    if (modalText.home && modalOpen === true) {
      redirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counter]);

  const stopLoopRedirect = () => setRedirectStop(true);

  const redirect = async () => {
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    if (modalOpen === true) {
      if (counter <= 0 && redirectStop === false) {
        navigate(redirectTo);
        return;
      }
      if (redirectStop === true) return;
      await wait(1000);
      setCounter((prev) => prev - 1);
    }
  };

  return (
    <Modal
      aria-labelledby={modalText.title}
      aria-describedby={modalText.description}
      open={modalOpen}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 500 } }}
    >
      <Fade in={modalOpen}>
        <Box sx={style}>
          <Typography
            sx={{
              color: "#05F842",
              fontWeight: 800,
              textShadow: "-2px 2px 5px #000",
              mb: 1,
            }}
            variant="h5"
            component="h2"
          >
            {modalText.title}
          </Typography>
          <Typography sx={{ mt: 1, color: "rgba(255,255,255,0.9)" }}>
            {modalText.description}
          </Typography>
          {modalText.home && !redirectStop && (
            <div style={{ marginTop: 16 }}>
              <div>Returning to Home in {counter}...</div>
              <Button onClick={stopLoopRedirect} sx={{ color: "#05F842" }}>
                Stay here
              </Button>
            </div>
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

export default TransitionsModalV2;
